import { Component, OnInit } from '@angular/core';
import { SessionService } from '../../shared/services/session.service';
import { serviceClientService } from '../../shared/services/serviceClient.service';
import { asesorContrato } from '../../shared/models/asesorContrato';
import { novedadAsesor } from '../../shared/models/novedadAsesor';
import swal from 'sweetalert2';
import { WresponseWrapper } from '../../shared/models/WresponseWrapper.model';
import { MenuUtility } from '../../shared/utilities/menu.utility';


@Component({
  selector: 'app-service-client',
  templateUrl: './service-client.component.html',
  styleUrls: ['./service-client.component.css']
})
export class ServiceClientComponent implements OnInit {

  public contratante: boolean;
  public asesorInfo: asesorContrato;
  public indicador: boolean = false;
  public novedad: novedadAsesor;
  public response: WresponseWrapper;
  showSpinnerDescargar: boolean;

  constructor(private _sessionService: SessionService, private serviceClientService: serviceClientService) {
    this.indicador = false;
    this.novedad = new novedadAsesor();
    this.response = new WresponseWrapper();
    this.showSpinnerDescargar = false;
  }

  ngOnInit() {
    this.contratante = this._sessionService.getCurrentUser().actualizacionMenu;
    this.getInfoAsesor();
    MenuUtility.selectOption('menuServicioAlCliente');
  }

  getInfoAsesor() {
    this.serviceClientService.getInfoAsesor().subscribe(
      success => {
        this.asesorInfo = success;
        this.indicador = true;
        //console.log(this.asesorInfo);
      },
      err => {
        console.log(err);
      }
    );
  }

  envioNovedad() {

    swal({
      width: '480px',
      title: 'Reportar Novedad',
      html: `<br/><p style="font-size: 14px">¿Desea registrar alguna novedad respecto a su contrato o su asesor?</p>`,
      type: 'warning',
      confirmButtonText: "Reportar",
      confirmButtonClass: 'btn btn-confirm-modal',
      showCancelButton: true,
      cancelButtonClass: 'btn btn-info',
      cancelButtonText: 'Cancelar',
      cancelButtonColor: "#DD6B55"
    }).then((result) => {
      if (result.value) {

        swal({
          title: 'Ingresa Una Observación',
          input: 'text',
          type: "info",
          inputAttributes: {
            autocapitalize: 'off'
          },
          showCancelButton: true,
          confirmButtonText: 'Enviar',
          confirmButtonClass: 'btn btn-confirm-modal',
          showLoaderOnConfirm: true,
          cancelButtonClass: 'btn btn-info',
          cancelButtonText: 'Cancelar',
          cancelButtonColor: "#DD6B55",
          inputPlaceholder: "Opcional",
          preConfirm: (ob) => {
            this.showSpinnerDescargar = true;

            this.novedad.ciudad = this._sessionService.getDataContract().city;
            this.novedad.email = this._sessionService.getCurrentUser().email
            this.novedad.identificacion = this._sessionService.getCurrentUser().documentId
            this.novedad.nombre = this._sessionService.getCurrentUser().name
            this.novedad.nombreUsuario = this._sessionService.getCurrentUser().user
            this.novedad.numCOntrato = this._sessionService.getCurrentUser().contractNumber
            this.novedad.identificacion = this._sessionService.getCurrentUser().documentId
            this.novedad.telefono = this._sessionService.getCurrentUser().celphone
            this.novedad.observacion = ob;


            this.serviceClientService.postEnviaNovedad(this.novedad).subscribe(
              success => {
                this.response = success;
                swal("Reporte Novedad", this.response.message, "success")
                this.showSpinnerDescargar = false;
              },
              err => {
                this.response = err;
                swal("Reporte Novedad", this.response.message, "error")
                this.showSpinnerDescargar = false;
              }
            );
          }
        })
      }
      else if (result.dismiss) {
        close()
      }
    })

  }

}




// WEBPACK FOOTER //
// /app/src/app/office/service-client/service-client.component.ts